import { format } from 'utils';

export interface PriceFormatProps {
  price: number;
  precision?: number;
  separator?: string;
}

const DEFAULT_PRECISION = 2;

export const priceFormat = ({ price, precision, separator }: PriceFormatProps) =>
  format(
    '{0}',
    price
      .toFixed(precision !== undefined ? precision : DEFAULT_PRECISION)
      .replace(/(\d*)(?=(\d{6}))/, '$1 ')
      .replace(/(\d*)(?=(\d{3}))/, '$1 ')
      .replace('.', separator || ',')
      .replace(',00', '')
  );
